/**
 * Created by JackCui on 2021/12/20
 */

export const FORM_POSITION_SPAN = {
  'left': '2',
  'right': '2',
  'top': '3'
}
